export default {
  currentSettings: (state, _, __, rootGetters) =>
    state.settings[rootGetters['core/location/active/id']],
  locationSettings: (state) => (locationId) => {
    return state.settings[locationId]
  },
}
